export default "__VITE_ASSET__iNpMCPI7__"